import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { RoutesService } from '../../../../shared/services/routes/routes.service';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';

@Injectable({
  providedIn: 'root'
})
export class ProListingPageGuard  {
  constructor(
      private readonly routesService: RoutesService,
      private readonly router: Router,
      private readonly localizeRouterService: LocalizeRouterService,
  ) {

  }
  canActivate(
      next: ActivatedRouteSnapshot,
      state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const pageNumberIsValid = (next.params?.page && !isNaN(parseInt(next.params.page, 10)));
    if (!pageNumberIsValid) {
      const parentRoute = this.routesService.getParentRoute(next);
      parentRoute.pop(); // remove '/page' to redirect to '/pro'
      this.router.navigate(this.localizeRouterService.translateRoute([...parentRoute]) as string[]);
      return false;
    }
    return true;
  }
}
